import { Dispatch } from "redux"
import { message } from "antd"
import { ApiChild } from "../../api/campaignApi"
import { PlacementsAction, PlacementsActionType } from "../types/placements"

const fetchPlacements = (data) => {
  return async (dispatch: Dispatch<PlacementsAction>) => {
    try {
      dispatch({ type: PlacementsActionType.FETCH_PLACEMENTS })
      const placementsData = await ApiChild(data)

      dispatch({
        type: PlacementsActionType.FETCH_PLACEMENTS_SUCCESS,
        payload: placementsData,
      })
      return placementsData
    } catch (e) {
      message.error("Failed to load placements")
      dispatch({
        type: PlacementsActionType.FETCH_PLACEMENTS_ERROR,
        payload: "sponsored product load error",
      })
      return null
    }
  }
}

export default {
  fetchPlacements,
}
